// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sync-direction {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background: #fff;
}

.sync-direction-header {
  text-align: center;
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}

.sync-direction-header h1 {
  font-size: 2.5rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1rem;
}

.sync-direction-header p {
  font-size: 1.1rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
}

.step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 2rem;
}

.sync-step {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.9rem;
  border: 2px solid #e5e7eb;
  background: white;
  color: #6b7280;
  padding: 1.5rem;
}

.sync-step.active {
  background: #3b82f6;
  border-color: #3b82f6;
  color: white;
  padding: 1.5rem;
}

.sync-step.completed {
  background: #10b981;
  border-color: #10b981;
  color: white;
  padding: 1.5rem;
}

.step-label {
  font-size: 0.9rem;
  color: #6b7280;
  margin-left: 0.5rem;
 
}
.syncing-progress .step-label{
  top: 2.2rem;
  position: relative;
  right: 2.5rem;
}

/* Sync Overview */
.sync-overview {
  margin-bottom: 3rem;
}

.sync-overview-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
}

.platform-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  flex: 1 1;
}

.platform-section h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #374151;
  margin: 0;
  text-align: center;
}

.platform-icon-add {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.platform-icon-add.salesforce {
  background: #00a1e0;
}

.platform-icon-add.hubspot {
  background: #ff7a59;
}

.platform-icon-add img {
  width: 32px;
  height: 32px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.sync-arrows {
  flex: 0 0 auto;
  margin: 0 2rem;
}

.checkmark {
  flex: 0 0 auto;
  margin-left: 1rem;
}

.sync-description {
  text-align: center;
  color: #6b7280;
  font-size: 0.95rem;
  margin: 0;
}

/* Error Messages */
.error-message {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #dc2626;
  font-size: 0.9rem;
}

.error-icon {
  font-size: 1.1rem;
}

/* Sync Sections */
.sync-sections {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.sync-section {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-header {
  padding: 1.5rem;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background-color 0.2s;
}

.section-header:hover {
  background: #f3f4f6;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.section-title h3 {
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  margin: 0;
  letter-spacing: 0.05em;
}

.expand-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
  color: #6b7280;
}

.expand-icon.expanded {
  transform: rotate(180deg);
}

.section-error {
  color: #dc2626;
  font-size: 1.1rem;
}

.section-content {
  padding: 0;
}

/* Rules Grid */
.rules-grid {
  display: flex;
  flex-direction: column;
}

.grid-headers {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
}

.header-left {
  text-align: left;
}

.header-right {
  text-align: left;
}

.rule-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto;
  gap: 1rem;
  padding: 1.5rem;
  align-items: center;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s;
}

.sync-direction-header .rule-row:last-child {
  border-bottom: none;
}

.rule-row.enabled {
  background: white;
}

.rule-row.disabled {
  background: #f9fafb;
  opacity: 0.7;
}

.rule-source,
.rule-target {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.rule-row.disabled .rule-source,
.rule-row.disabled .rule-target {
  background: #f1f5f9;
  border-color: #e2e8f0;
}

.rule-text {
  font-size: 0.9rem;
  color: #374151;
  line-height: 1.4;
}

.rule-row.disabled .rule-text {
  color: #9ca3af;
}

.rule-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
}

.rule-row.disabled .rule-arrow {
  color: #d1d5db;
}

/* Toggle Switch */
.rule-toggle {
  display: flex;
  justify-content: center;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cbd5e1;
  transition: 0.3s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

input:checked + .toggle-slider {
  background-color: #3b82f6;
}

input:checked + .toggle-slider:before {
  transform: translateX(24px);
}

.section-error-message {
  padding: 1rem 1.5rem;
  background: #fef2f2;
  border-top: 1px solid #fecaca;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #dc2626;
  font-size: 0.9rem;
}

/* Sync Note */
.sync-note {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 3rem;
}

.note-content {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.9rem;
  line-height: 1.5;
}

.note-label {
  font-weight: 600;
  color: #0369a1;
  flex-shrink: 0;
}

.note-text {
  color: #0c4a6e;
}

.learn-more-link {
  color: #0369a1;
  text-decoration: none;
  font-weight: 500;
  margin-left: 0.25rem;
}

.learn-more-link:hover {
  text-decoration: underline;
}

/* Actions Section */
.actions-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
}

.back-button {
  background: #f9fafb;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.back-button:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.continue-button {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.continue-button:hover:not(:disabled) {
  background: #2563eb;
}

.continue-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

/* Loading Container */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 1rem;
}

.loading-container h2 {
  color: #374151;
  margin: 0;
}

.loading-container p {
  color: #6b7280;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .sync-direction {
    padding: 1rem;
  }

  .sync-overview-card {
    flex-direction: column;
    gap: 2rem;
    padding: 1.5rem;
  }

  .sync-arrows {
    margin: 0;
    transform: rotate(90deg);
  }

  .grid-headers,
  .rule-row {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .rule-arrow {
    transform: rotate(90deg);
    margin: 0.5rem 0;
  }

  .actions-section {
    flex-direction: column;
    gap: 1rem;
  }

  .back-button,
  .continue-button {
    width: 100%;
    justify-content: center;
  }

  .note-content {
    flex-direction: column;
    gap: 0.25rem;
  }
}

@media (max-width: 480px) {
  .sync-direction-header h1 {
    font-size: 2rem;
  }

  .platform-section h3 {
    font-size: 1rem;
  }

  .rule-source,
  .rule-target {
    padding: 0.75rem;
  }

  .rule-text {
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector-Screen/SyncDirection/SyncDirection.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8EAA8E;EAC9E,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;;AAErB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".sync-direction {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  background: #fff;\n}\n\n.sync-direction-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n}\n\n.sync-direction-header h1 {\n  font-size: 2.5rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 1rem;\n}\n\n.sync-direction-header p {\n  font-size: 1.1rem;\n  color: #6b7280;\n  margin-bottom: 0.5rem;\n}\n\n.step-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-top: 2rem;\n}\n\n.sync-step {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 0.9rem;\n  border: 2px solid #e5e7eb;\n  background: white;\n  color: #6b7280;\n  padding: 1.5rem;\n}\n\n.sync-step.active {\n  background: #3b82f6;\n  border-color: #3b82f6;\n  color: white;\n  padding: 1.5rem;\n}\n\n.sync-step.completed {\n  background: #10b981;\n  border-color: #10b981;\n  color: white;\n  padding: 1.5rem;\n}\n\n.step-label {\n  font-size: 0.9rem;\n  color: #6b7280;\n  margin-left: 0.5rem;\n \n}\n.syncing-progress .step-label{\n  top: 2.2rem;\n  position: relative;\n  right: 2.5rem;\n}\n\n/* Sync Overview */\n.sync-overview {\n  margin-bottom: 3rem;\n}\n\n.sync-overview-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1rem;\n}\n\n.platform-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  flex: 1;\n}\n\n.platform-section h3 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #374151;\n  margin: 0;\n  text-align: center;\n}\n\n.platform-icon-add {\n  width: 48px;\n  height: 48px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n}\n\n.platform-icon-add.salesforce {\n  background: #00a1e0;\n}\n\n.platform-icon-add.hubspot {\n  background: #ff7a59;\n}\n\n.platform-icon-add img {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n  filter: brightness(0) invert(1);\n}\n\n.sync-arrows {\n  flex: 0 0 auto;\n  margin: 0 2rem;\n}\n\n.checkmark {\n  flex: 0 0 auto;\n  margin-left: 1rem;\n}\n\n.sync-description {\n  text-align: center;\n  color: #6b7280;\n  font-size: 0.95rem;\n  margin: 0;\n}\n\n/* Error Messages */\n.error-message {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 2rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #dc2626;\n  font-size: 0.9rem;\n}\n\n.error-icon {\n  font-size: 1.1rem;\n}\n\n/* Sync Sections */\n.sync-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n}\n\n.sync-section {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.section-header {\n  padding: 1.5rem;\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  transition: background-color 0.2s;\n}\n\n.section-header:hover {\n  background: #f3f4f6;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.section-title h3 {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #374151;\n  margin: 0;\n  letter-spacing: 0.05em;\n}\n\n.expand-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s;\n  color: #6b7280;\n}\n\n.expand-icon.expanded {\n  transform: rotate(180deg);\n}\n\n.section-error {\n  color: #dc2626;\n  font-size: 1.1rem;\n}\n\n.section-content {\n  padding: 0;\n}\n\n/* Rules Grid */\n.rules-grid {\n  display: flex;\n  flex-direction: column;\n}\n\n.grid-headers {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr auto;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.header-left {\n  text-align: left;\n}\n\n.header-right {\n  text-align: left;\n}\n\n.rule-row {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr auto;\n  gap: 1rem;\n  padding: 1.5rem;\n  align-items: center;\n  border-bottom: 1px solid #f3f4f6;\n  transition: all 0.2s;\n}\n\n.sync-direction-header .rule-row:last-child {\n  border-bottom: none;\n}\n\n.rule-row.enabled {\n  background: white;\n}\n\n.rule-row.disabled {\n  background: #f9fafb;\n  opacity: 0.7;\n}\n\n.rule-source,\n.rule-target {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.rule-row.disabled .rule-source,\n.rule-row.disabled .rule-target {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n}\n\n.rule-text {\n  font-size: 0.9rem;\n  color: #374151;\n  line-height: 1.4;\n}\n\n.rule-row.disabled .rule-text {\n  color: #9ca3af;\n}\n\n.rule-arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n}\n\n.rule-row.disabled .rule-arrow {\n  color: #d1d5db;\n}\n\n/* Toggle Switch */\n.rule-toggle {\n  display: flex;\n  justify-content: center;\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 24px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #cbd5e1;\n  transition: 0.3s;\n  border-radius: 24px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\ninput:checked + .toggle-slider {\n  background-color: #3b82f6;\n}\n\ninput:checked + .toggle-slider:before {\n  transform: translateX(24px);\n}\n\n.section-error-message {\n  padding: 1rem 1.5rem;\n  background: #fef2f2;\n  border-top: 1px solid #fecaca;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #dc2626;\n  font-size: 0.9rem;\n}\n\n/* Sync Note */\n.sync-note {\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 3rem;\n}\n\n.note-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.note-label {\n  font-weight: 600;\n  color: #0369a1;\n  flex-shrink: 0;\n}\n\n.note-text {\n  color: #0c4a6e;\n}\n\n.learn-more-link {\n  color: #0369a1;\n  text-decoration: none;\n  font-weight: 500;\n  margin-left: 0.25rem;\n}\n\n.learn-more-link:hover {\n  text-decoration: underline;\n}\n\n/* Actions Section */\n.actions-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 2rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.back-button {\n  background: #f9fafb;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.back-button:hover {\n  background: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.continue-button {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.continue-button:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.continue-button:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Loading Container */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 1rem;\n}\n\n.loading-container h2 {\n  color: #374151;\n  margin: 0;\n}\n\n.loading-container p {\n  color: #6b7280;\n  margin: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .sync-direction {\n    padding: 1rem;\n  }\n\n  .sync-overview-card {\n    flex-direction: column;\n    gap: 2rem;\n    padding: 1.5rem;\n  }\n\n  .sync-arrows {\n    margin: 0;\n    transform: rotate(90deg);\n  }\n\n  .grid-headers,\n  .rule-row {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .rule-arrow {\n    transform: rotate(90deg);\n    margin: 0.5rem 0;\n  }\n\n  .actions-section {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .back-button,\n  .continue-button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .note-content {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .sync-direction-header h1 {\n    font-size: 2rem;\n  }\n\n  .platform-section h3 {\n    font-size: 1rem;\n  }\n\n  .rule-source,\n  .rule-target {\n    padding: 0.75rem;\n  }\n\n  .rule-text {\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
